import React, { useState } from "react";
import { Input, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import apiHelpers from "./data";
import CustomerForm from "./customerForm";
import FullPageLoader from "../common/FullPageLoader";
import ErrorNotification from "../common/ErrorNotification";

const CustomersView = () => {
  const [email, setEmail] = useState("");
  const [customer, setCustomer] = useState(null);
  const [isloader, setisloader] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [searched, setSearched] = useState(false);
  const [alert, setAlert] = useState({});

  const showAlert = (type, title, message, isopen = true) => {
    setAlert({ type, title, message, isopen });
    setTimeout(() => setAlert({ isopen: false }), 100);
  };

  const handleSearch = async () => {
    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      showAlert("error", "Validation", "Please enter a customer email");
      return;
    }

    setisloader(true);
    setSearched(true);
    const response = await apiHelpers.getCustomerByEmail(trimmedEmail);
    setisloader(false);

    if (response.success && response.data) {
      setCustomer(response.data);
      showAlert("success", "Success", response.message);
    } else {
      setCustomer(null);
      showAlert("error", "Not Found", response.message || "Customer not found");
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const handleUpdate = async (payload) => {
    if (!customer?.id) {
      showAlert("error", "Error", "Customer ID is missing");
      return;
    }

    setUpdating(true);
    const response = await apiHelpers.updateCustomer(customer.id, payload);
    setUpdating(false);

    if (response.success) {
      setCustomer(response.data || { ...customer, ...payload });
      showAlert("success", "Success", response.message);
    } else {
      showAlert("error", "Update Failed", response.message || "Failed to update customer");
    }
  };

  return (
    <div className="Customers-page">
      <div className="Customers-search-panel">
        <div className="Customers-search-copy">
          <h3 className="Customers-search-title">Find a customer</h3>
          <p className="Customers-search-subtitle">
            Search by email to load and review their membership profile.
          </p>
        </div>
        <div className="Customers-search-box">
          <Input
            allowClear
            size="large"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="e.g. jane.doe@example.com"
            className="Customers-search-input"
            prefix={<SearchOutlined />}
          />
          <Button
            type="primary"
            size="large"
            className="Customers-search-btn"
            onClick={handleSearch}
            loading={isloader}
          >
            Search
          </Button>
        </div>
      </div>

      <div className="Customers-content-box">
        {customer ? (
          <CustomerForm
            customer={customer}
            onUpdate={handleUpdate}
            updating={updating}
          />
        ) : (
          !isloader && (
            <div className="Customers-empty-state">
              {searched
                ? "No customer found for this email."
                : "Enter an email above to view customer details."}
            </div>
          )
        )}

        <FullPageLoader isloader={isloader} />
        <ErrorNotification {...alert} />
      </div>
    </div>
  );
};

export default CustomersView;
